export enum UserRole {
  SUPER_ADMIN = 'SuperAdmin',
  ORGANIZATION_ADMIN = 'OrganizationAdmin',
  ORGANIZATION_EDITOR = 'OrganizationEditor',
  ORGANIZATION_READER = 'OrganizationReader',
}

export const userRoleLabels: Record<UserRole, string> = {
  [UserRole.SUPER_ADMIN]: 'Super Admin',
  [UserRole.ORGANIZATION_ADMIN]: 'Organization Admin',
  [UserRole.ORGANIZATION_EDITOR]: 'Organization Editor',
  [UserRole.ORGANIZATION_READER]: 'Organization Reader',
};

export const getAllRoles = (): UserRole[] => Object.values(UserRole);

export const getRoleLabel = (role: UserRole): string => userRoleLabels[role];
